import { columnType } from "./columnValues";
import type {
  ColumnType,
  DataTableColDef,
  FilterItem,
  FilterOperatorDef,
} from "./types";

export type { FilterOperatorDef } from "./types";

const isEmpty: FilterOperatorDef = {
  value: "isEmpty",
  label: "is empty",
  input: "none",
};
const isNotEmpty: FilterOperatorDef = {
  value: "isNotEmpty",
  label: "is not empty",
  input: "none",
};
const isAnyOf: FilterOperatorDef = {
  value: "isAnyOf",
  label: "is any of",
  input: "multi",
};

// Operator values match MUI's, which the per-dashboard backend mappers expect.
export const FILTER_OPERATORS: Record<ColumnType, FilterOperatorDef[]> = {
  string: [
    { value: "contains", label: "contains", input: "single" },
    { value: "equals", label: "equals", input: "single" },
    { value: "startsWith", label: "starts with", input: "single" },
    { value: "endsWith", label: "ends with", input: "single" },
    isEmpty,
    isNotEmpty,
    isAnyOf,
  ],
  number: [
    { value: "=", label: "=", input: "single" },
    { value: "!=", label: "!=", input: "single" },
    { value: ">", label: ">", input: "single" },
    { value: ">=", label: ">=", input: "single" },
    { value: "<", label: "<", input: "single" },
    { value: "<=", label: "<=", input: "single" },
    isEmpty,
    isNotEmpty,
    isAnyOf,
  ],
  date: [
    { value: "is", label: "is", input: "single" },
    { value: "not", label: "is not", input: "single" },
    { value: "after", label: "is after", input: "single" },
    { value: "onOrAfter", label: "is on or after", input: "single" },
    { value: "before", label: "is before", input: "single" },
    { value: "onOrBefore", label: "is on or before", input: "single" },
    isEmpty,
    isNotEmpty,
  ],
  singleSelect: [
    { value: "is", label: "is", input: "single" },
    { value: "not", label: "is not", input: "single" },
    isAnyOf,
  ],
  boolean: [{ value: "is", label: "is", input: "single" }],
  actions: [],
};

export const EMPTY_FILTER_OPERATORS: FilterOperatorDef[] = [
  isEmpty,
  isNotEmpty,
];

export function operatorsFor<R>(
  column: DataTableColDef<R>,
): FilterOperatorDef[] {
  return column.filterOperators ?? FILTER_OPERATORS[columnType(column)];
}

export function findOperator<R>(
  column: DataTableColDef<R>,
  operator: string,
): FilterOperatorDef | undefined {
  return operatorsFor(column).find((op) => op.value === operator);
}

export function isActiveFilterItem<R>(
  item: FilterItem,
  column: DataTableColDef<R>,
): boolean {
  const operator = findOperator(column, item.operator);
  if (!operator) return false;
  if (operator.input === "none") return true;
  if (operator.input === "multi") {
    return Array.isArray(item.value) && item.value.length > 0;
  }
  return item.value !== undefined && item.value !== "";
}
